module.exports = __webpack_public_path__ + "static/assets/3c4b925a34ffe0e54967bdb7c4d0644c.svg";